import companyService from "@/services/company";
import serviceHandler from "@/helpers/handlers/service";

import moment from "moment";
import isEmpty from "lodash/isEmpty";
import { mapState } from "vuex";

export default {
  name: "SocialMediaChartData",
  props: {
    socialMediaItem: {
      type: Object,
      default: () => {}
    },
    selectedChartItem: {
      type: Object,
      default: () => {}
    },
    month: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      chartLoading: false,
      currentMonth: {},
      chartData: {
        labels: [],
        data: []
      },
      selected: {},
      items: {
        facebook: [
          {
            label: "Ogólna ocena",
            value: "score",
            scale: { min: 0, suggestedMax: 100 }
          },
          {
            label: "Polubienia",
            value: "likes",
            scale: { min: 0, suggestedMax: 100 }
          }
        ],
        instagram: [
          {
            label: "Ogólna ocena",
            value: "score",
            scale: { min: 0, suggestedMax: 100 }
          },
          {
            label: "Liczba obserwujących",
            value: "followers",
            scale: { min: 0, suggestedMax: 100 }
          },
          {
            label: "Liczba obserwowanych",
            value: "following",
            scale: { min: 0, suggestedMax: 100 }
          },
          {
            label: "Liczba postów",
            value: "number_of_posts",
            scale: { min: 0, suggestedMax: 100 }
          }
        ]
      }
    };
  },

  computed: {
    ...mapState({
      companyId: state => state.company.id
    })
  },

  async created() {
    await this.getCurrentMonth();
    await this.fetchSocialMediaAuditsHistory();
  },

  watch: {
    "selectedChartItem.value"(newValue) {
      this.selected = newValue;
      this.fetchSocialMediaAuditsHistory(newValue);
    },

    month(newValue) {
      this.getCurrentMonth(newValue);
      this.fetchSocialMediaAuditsHistory(this.selected.value);
    }
  },

  methods: {
    getCurrentMonth(month) {
      month = month || moment();
      this.currentMonth = month;
    },

    async fetchSocialMediaAuditsHistory(type) {
      this.chartLoading = true;
      type = type || this.items[this.socialMediaItem.name][0].value;

      const payload = {
        from: moment(this.currentMonth)
          .startOf("month")
          .format("YYYY-MM-DD"),
        to: moment(this.currentMonth)
          .endOf("month")
          .startOf("day")
          .format("YYYY-MM-DD")
      };

      const service =
        this.socialMediaItem.name === "facebook"
          ? companyService.getFacebookAuditsHistory
          : companyService.getInstagramAuditsHistory;

      const data = await serviceHandler(service(this.companyId, payload, type));

      if (data.length > 0) {
        let obj = {
          data: [],
          labels: []
        };

        data.map(item => {
          obj.data.push({ y: item[type], t: item.created_at });
          obj.labels.push(item.created_at);
        });

        this.chartData = obj;
        this.chartLoading = false;
        return;
      }

      this.chartData = {
        data: [],
        labels: []
      };

      this.chartLoading = false;
    }
  },

  render() {
    return this.$scopedSlots.default({
      currentMonth: this.currentMonth,
      chartData: this.chartData,
      items: this.items[this.socialMediaItem.name],
      select: !isEmpty(this.selectedChartItem)
        ? this.selectedChartItem
        : this.items[this.socialMediaItem.name][0],
      chartLoading: this.chartLoading
    });
  }
};
